module.exports = __webpack_public_path__ + "img/infograph_7.103e5357.png";